import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-navy" data-id="element-49" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-50" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-51" data-mp="1v05w65xky8j2">
          Stop choosing. <span className="text-gold" data-id="element-52" data-mp="1q1m5xtbyeakw">Start coaching from a system.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-53" data-mp="1l29ojo3upvpp">
          Four dated quarters, an adaptation matrix and a coaching &amp; retention
          playbook. 156 sessions — decided, in order, printable.
        </p>

        <div className="mt-7" data-id="element-54" data-mp="1790hvv7afoav">
          <Countdown size="sm" tone="dark" data-id="element-55" data-mp="179tisfjkfjl3" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-56" data-mp="129nrx1l4e142">
          <div data-id="element-57" data-mp="xbcl6zq4g6q2">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-58" data-mp="xcnm8rs6n0dh">Complete package</span>
            <span className="text-[15px] font-bold text-white" data-id="element-59" data-mp="40r37ivl9258">The Decided Bootcamp — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-60" data-mp="3li0kreuuh3du">
            <span className="text-[15px] text-white/60 line-through" data-id="element-61" data-mp="3lfed7f7yenvm">$97</span>
            <span className="font-display text-4xl leading-none text-white" data-id="element-62" data-mp="3qglj18qjdczn">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-63" data-mp="hyo1cjpoxgm0">
          <CtaButton data-id="element-64" data-mp="myk64l67pc2m">Yes, I want The Decided Bootcamp — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-65" data-mp="82uhef9n6ku7">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-66" data-mp="2sstluerhabs2">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-67" data-mp="2sr8t8uoq52wu" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}